import { render, staticRenderFns } from "./sfc-gtm-body.vue?vue&type=template&id=2bae9352&"
import script from "./sfc-gtm-body.vue?vue&type=script&lang=js&"
export * from "./sfc-gtm-body.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports